// extracted by mini-css-extract-plugin
export default {"fBody":"Faqbody_fBody__jDop0","header":"Faqbody_header__cAXkp","content":"Faqbody_content__zdofu","block":"Faqbody_block__Q-WbB","activeBlockC":"Faqbody_activeBlockC__R4hds"};